import React, { useEffect, useState } from "react";
import { Tooltip, Box, Typography, IconButton, Button } from '@mui/material';
import Card from "../../components/card/Card";
import TableContainer from "../../components/table/table";
import { useDispatch, useSelector } from "react-redux";
import { getReports } from "../../store/actions/report";
import ModalButton from "../../components/modalButton/modalButton";
import details from '../../assets/details.png'
import ReportDetail from "./reportDetail";
import moment from "moment";

const Report = () => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch()
    const auth = useSelector(state => state.auth)
    const [dataList, setDataList] = useState([])

    const tableHeader = ['Request Date', 'Requested Time', 'Status', 'Created By']
    const verifyParam = ['requestDate', 'requestTime', 'statusName', 'createdByName']

    useEffect(() => {
        setIsLoading(true)
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETRFTSPWSAME",
            "data": { "CompanyID": auth.user?.businessId },
            "debug": null,
            "token": null
        }
        dispatch(getReports(data)).then(res => {
            let products = res.payload.data

            const merged = [];
            products.forEach(item => {
                const existing = merged.find(i => i.rftsid === item.rftsid);

                const productDetails = { ...item };

                if (existing) {
                    existing.products.push(productDetails);
                } else {
                    const newItem = {
                        id: item.id,
                        rftsid: item.rftsid,
                        comments: item.comments,
                        requestDate: (moment(item.rftsDate).format("YYYY-MM-DD")),
                        requestTime: (moment(item.rftsDate).format("h:mm a")),
                        statusName: item.statusName,
                        createdBy: item.createdBy,
                        createdByName: item.username
                    };
                    newItem.products = [productDetails];
                    merged.push(newItem);
                }
            })
            setDataList(merged)
            console.log(merged)
            setIsLoading(false)
        })
    }, [])




    return (
        <>
            <Box sx={{ margin: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h1' >Report</Typography>
            </Box>
            <Card style={{ flex: 1, overflow: 'auto' }}>
                <TableContainer tableHeader={tableHeader}
                    data={dataList.filter(val => val.Role !== 'Super Admin')}
                    verifyParam={verifyParam}
                    isLoading={isLoading}
                    action={TableAction}
                />
            </Card>
        </>
    );
};

export default Report;


const TableAction = ({ id }) => {
    const [openEdit, setOpenEdit] = React.useState(false);
    return (
        <ModalButton open={openEdit} setOpen={setOpenEdit} tooltip={'Add Comments'} img={details} type={'icon'}>
            <ReportDetail data={id} setOpen={setOpenEdit} />
        </ModalButton>
    )
}